/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
    IOLinesMode,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import Tibbits from '@appblocks/codegeneration/Tibbits';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import IOTibbit from '@appblocks/codegeneration/Tibbits/_IOTibbit';

export const getCodeBlocks = (feature: IOTibbit): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const currentSocket = Number(feature.getSettingValue('SOCKET'));
    const nextSocket = (currentSocket + 1).toString();
    const featureId = feature.getID();
    let connector = '';
    const connectorSocket = nextSocket;
    let connectorTibbit;
    let lcdEnabled;

    for (let i = 0; i < project.features.length; i += 1) {
        if (project.features[i].getSettingValue('SOCKET') === nextSocket) {
            connector = project.features[i].getSettingValue('TIBBIT');
            connectorTibbit = project.features[i];
        }
        if (project.features[i].id === 'lcd') {
            lcdEnabled = project.features[i].getSettingValue('ENABLED');
        }
    }

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        id: 'ioLineGet',
        template: `
function ioLineGet(featureId, line) {
    return simulator.context[featureId][line];
}
        `,
    });

    // for each line
    for (let i = 1; i <= feature.lines; i += 1) {
        const LNAME = `L${i}NAME`;
        const LMODE = `L${i}MODE`;
        const LSTATE = `L${i}STATE`;
        let LSTATECODE = '';
        let mode = feature.getSettingValue(LMODE);
        if (mode === undefined || mode === '') {
            mode = IOLinesMode.Output;
        }
        const VARNAME = feature.getSettingValue(LNAME);
        const variable = project.getVariableByName(VARNAME);
        let interruptEnum;
        let interruptNumber;
        let interruptValue;
        let interruptBit;

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
this.updateContext("${featureId}", {
    "${LNAME}": ${variable?.getSettingValue('DEFAULT')},
});
        `,
        });

        switch (mode) {
            case IOLinesMode.Button:
//                 blocks.push({
//                     location: 'boot',
//                     blockType: BlockType.CODE,
//                     template: `
// '${feature.name} with tibbit button input mode on socket ${connectorSocket}
// io.num=S${feature.getSettingValue('SOCKET')}_${feature.getSettingValue(LNAME)}_Button
// io.enabled=NO`,
//                 });

                blocks.push({
                    location: 'GLOBAL_CONSTS',
                    blockType: BlockType.CODE,
                    template: `
const S${feature.getSettingValue('SOCKET')}_${feature.getSettingValue(LNAME)}_Button = ${Tibbits.getSocketPins(feature.getSettingValue('SOCKET'), feature.project.device.id)[i - 1]};`,
                });
                break;
            case IOLinesMode.Standard:
                // blocks.push({
                //     location: `var_${VARNAME}_set`,
                //     blockType: BlockType.CODE,
                //     template: `ioLineSet("${feature.getSettingValue(LNAME)}", value)`,
                // });
                break;
            case IOLinesMode.Output:
                LSTATECODE = variable?.getSettingValue('DEFAULT') === '1' ? 'io.state=HIGH' : 'io.state=LOW';
                blocks.push({
                    location: `var_${VARNAME}_set`,
                    blockType: BlockType.CODE,
                    template: `ioLineSet("${featureId}", "${LNAME}", value)`,
                });
                break;
            case IOLinesMode.Interrupt:
                interruptNumber = Tibbits.getSocket(feature.getSettingValue('SOCKET'), feature.project.device.id)?.interrupt;
                if (!interruptNumber) {
                    break;
                }
                interruptEnum = PlatformUtils.getEnum(interruptNumber, 'pl_int_num', feature.project.device.platform);
                interruptValue = PlatformUtils.getEnumValue(interruptNumber, 'pl_int_num', feature.project.device.platform);
                interruptBit = Math.pow(2, Number(interruptValue));
                const intEdge = feature.getSettingValue('INTEDGE');

                blocks.push({
                    location: 'FUNCTION_DEFINITIONS',
                    blockType: BlockType.CODE,
                    id: 'on_io_int',
                    template: `
function on_io_int(line, edge) {
    const intcount = 1;
    /****on_io_int****/
}
                    `,
                });

                blocks.push({
                    location: 'on_io_int',
                    blockType: BlockType.CODE,
                    id: feature.getID(),
                    template: `
    if (line === "${feature.getSettingValue(LNAME)}_int"
        && ${intEdge === 'INT_EDGE_BOTH' ? 'true' : `edge === "${intEdge}"`}
    ) {
    /****on_io_int_${interruptNumber}****/
    }
                    `,
                });

                // blocks.push({
                //     location: 'boot',
                //     blockType: BlockType.CODE,
                //     id: 'io_int_mode_set',
                //     template: 'io.intmode=1',
                // });

//                 blocks.push({
//                     location: 'boot',
//                     blockType: BlockType.CODE,
//                     template: `
// 'Tibbit ${feature.name} setup on socket ${feature.getSettingValue('SOCKET')}
// io.num=${feature.getSettingValue(LNAME)}_num
// io.enabled=NO
// io.intnum=S${feature.getSettingValue('SOCKET')}_INT_NUM
// io.intedge=${feature.getSettingValue('INTEDGE')}
// io.intenabled=YES`,
//                 });

        //         blocks.push({
        //             location: 'on_io_int',
        //             blockType: BlockType.CODE,
        //             id: feature.getID(),
        //             template: `
        // if (linestate and ${interruptBit}) <> 0 then
        //     io.intnum=${interruptNumber}
        //     dim intcount as word=io.intcount
        //     io.intcount=0
        //     '****on_io_int_${interruptNumber}****'
        // end if`,
        //         });

                // blocks.push({
                //     location: 'GLOBAL_CONSTS',
                //     blockType: BlockType.CODE,
                //     template: `const S${feature.getSettingValue('SOCKET')}_INT_NUM = ${interruptEnum}`,
                // });
                break;
            default:
                break;
        }

        blocks.push({
            location: `var_${VARNAME}_update`,
            blockType: BlockType.CODE,
            template: `var_${VARNAME}_update_completed(simulator.context["${featureId}"]["${LNAME}"]);`,
        });
    }

    return blocks;
};
